"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchRandomActionEventHandlerActivator = exports.DispatchRandomActionEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
const Random_1 = require("../../../utils/Random");
class DispatchRandomActionEventHandlerArgs {
    constructor(dispatchSubject, percentChance, oneOf, 
    // diminishing returns
    useDR = false) {
        this.dispatchSubject = dispatchSubject;
        this.percentChance = percentChance;
        this.oneOf = oneOf;
        this.useDR = useDR;
        this.__type = EventHandlerType_1.EventHandlerType.DispatchRandomAction;
        this.__typeName = "DispatchRandomAction";
    }
}
exports.DispatchRandomActionEventHandlerArgs = DispatchRandomActionEventHandlerArgs;
let DispatchRandomActionEventHandlerActivator = class DispatchRandomActionEventHandlerActivator {
    activate(sequence, container, handler, event) {
        var _a, _b, _c;
        if (handler.args.oneOf.length === 0) {
            return;
        }
        let percentChance = handler.args.percentChance;
        if (handler.args.useDR) {
            const lastTurn = (_a = handler.meta.drTrackedAt) !== null && _a !== void 0 ? _a : 0;
            if (container.lastTurnStartedAt !== lastTurn) {
                handler.meta.drCounter = 0;
                handler.meta.drTrackedAt = container.lastTurnStartedAt;
            }
            percentChance = Math.max(1, percentChance / (((_b = handler.meta.drCounter) !== null && _b !== void 0 ? _b : 0) + 1));
        }
        if ((0, Random_1.randomPercent)() <= percentChance) {
            handler.meta.drCounter = ((_c = handler.meta.drCounter) !== null && _c !== void 0 ? _c : 0) + 1;
            const nextAction = (0, Random_1.randomElement)(handler.args.oneOf);
            container.dispatch(sequence, handler.args.dispatchSubject, nextAction);
        }
    }
};
DispatchRandomActionEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.DispatchRandomAction)
], DispatchRandomActionEventHandlerActivator);
exports.DispatchRandomActionEventHandlerActivator = DispatchRandomActionEventHandlerActivator;
